<template>
  <div>
    <div class="page-title">资金总收付统计</div>
    <page-search
      :layout="['customName', 'export', 't_agent_info_agent_name']"
      @search="search"
      @exportTable="exportTable"
    ></page-search>
    <page-tab
      :tabs="tabs"
      :nowTab="nowTab"
      :isParams="true"
      :paramsLabel="'index'"></page-tab>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageIndex="page"
      :pageSize="pageSize"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import pageTab from '@/components/pageCom/pageTab.vue'

import { addQuery, formatTitle } from '@/utils/common'
import { downFile } from '@/utils/file'
import { getMoneyStatisticsTab, getMoneyStatistics } from '@/api/settleAccounts'
export default {
  name: 'fundCount',
  components: {
    pageTab,
    pageSearch,
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      tabs: [],
      col: [
        { field: 'sId', title: '序号', width: 80, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cust_no', title: '企业编码', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, titleAlign: 'left', columnAlign: 'left', formatter(rowData, index, pageIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cust_name', title: '客户名称', width: 220, titleAlign: 'left', columnAlign: 'left', formatter(rowData, index, pageIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'receiver_account_money', title: '收款账户余额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'payer_account_money', title: '付款账号余额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'amount_money', title: '总余额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      queryName: '', // 搜索的企业名称
      t_agent_info_agent_name: '' // 渠道
    }
  },
  computed: {
    nowTab() {
      if (this.tabs.length === 0) {
        return ''
      } else {
        const nowLink = Number(this.$route.params.index) - 1
        if (nowLink >= this.tabs.length) {
          this.goFirst()
          return '1'
        } else {
          return this.tabs[nowLink].linkName.toString()
        }
      }
    }
  },
  methods: {
    initPage() {
      this.getTab()
      this.queryName = ''
      this.t_agent_info_agent_name = ''
    },
    // 获取表格数据
    getData() {
      let query = {
        per_page: this.pageSize,
        page: this.page
      }
      if (this.tabs.length === 0) {
        return false
      }
      const tabIndex = this.tabs.map(item => item.linkName).indexOf(this.nowTab)
      query.year = this.tabs[tabIndex].year
      query.month = this.tabs[tabIndex].month
      query = addQuery(query, 'cust_name', this.queryName)
      query = addQuery(query, 't_agent_info_agent_name', this.t_agent_info_agent_name)
      this.tableLoading = true
      getMoneyStatistics(query).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          if (res.result === undefined || res.result === null || !Array.isArray(res.result.data)) {
            this.tableData = []
            this.total = 0
          } else {
            this.tableData = res.result.data.map((item, index) => {
              if (this.page > 1) {
                item.sId = (this.page - 1) * this.pageSize + index + 1
              } else {
                if (index === 0) {
                  item.sId = '合计'
                } else {
                  item.sId = index
                }
              }
              return item
            })
            this.total = res.result.total
          }
        }
      })
    },
    // 搜索
    search(query) {
      this.queryName = query.customName || ''
      this.t_agent_info_agent_name = query.t_agent_info_agent_name || ''
      this.initTable()
      this.getData()
    },
    exportTable() {
      const index = this.tabs.map(item => item.linkName).indexOf(this.nowTab)

      const query = {
        cust_name: this.queryName, // 客户名称。
        t_agent_info_agent_name: this.t_agent_info_agent_name,
        year: this.tabs[index].year, //  年份，4位，如2019。
        month: this.tabs[index].month // 月份，2位，如09。
      }
      const url = process.env.VUE_APP_BASE_API + '/settlement/export_excel'
      downFile(url, query)
    },
    // 超长回第一个
    goFirst() {
      this.$router.push({ path: '/settle/fund-count/1' })
    },
    // 构造tab
    getTab() {
      getMoneyStatisticsTab().then(res => {
        this.tabs = []
        this.total = 0
        if (res.code === 0) {
          if (res.result !== undefined && res.result !== null && Array.isArray(res.result.data)) {
            this.tabs = res.result.data.sort((a, b) => {
              if (Number(a.year) - Number(b.year) > 0) {
                if (Number(a.month) - Number(b.month) > 0) {
                  return 1
                } else {
                  return -1
                }
              } else {
                return 1
              }
            }).map((item, index) => {
              return {
                linkName: (index + 1).toString(),
                text: item.year + '年' + item.month + '月',
                year: item.year,
                month: item.month
              }
            })
            this.getData()
          }
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    }
  }
}
</script>

